import { BoxMaintenanceBloc } from "./bloc.box";
import { CloudMaintenanceBloc } from "./bloc.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseMaintenanceBloc } from "./bloc.base";
import environment from "@/config";

export default getService<BaseMaintenanceBloc>(environment.nexus, {
    box: new BoxMaintenanceBloc(),
    cloud: new CloudMaintenanceBloc(),
});